export default __webpack_public_path__ + "static/1760-e841076012dffd086a4e9e21987ed497.jpeg";